module.exports = __webpack_public_path__ + "static/media/A1.5a91bd7c.jpeg";